import { createPortal } from 'react-dom';

/**
 * Size guide modal — embeds the model sizeGuideUrl (WP/Elementor page) in an iframe.
 */
export function SizeGuideModal({ url, onClose }: { url: string; onClose: () => void }) {
  const host =
    typeof document !== 'undefined'
      ? (document.querySelector('.ox-root') ?? document.body)
      : null;

  if (!host) return null;

  return createPortal(
    <div className="ox-modal-backdrop ox-size-guide-backdrop" onClick={onClose}>
      <div
        className="ox-modal ox-size-guide-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label="Guía de tallas"
      >
        <header>
          <h2>Guía de tallas</h2>
          <button type="button" onClick={onClose} aria-label="Cerrar">
            ✕
          </button>
        </header>
        <iframe
          className="ox-size-guide-frame"
          src={url}
          title="Guía de tallas"
          loading="lazy"
        />
        <p className="ox-size-guide-open">
          <a href={url} target="_blank" rel="noreferrer">
            Abrir en pestaña nueva
          </a>
        </p>
      </div>
    </div>,
    host,
  );
}
